import script from "./Vehicles.vue?vue&type=script&setup=true&lang=js"
export * from "./Vehicles.vue?vue&type=script&setup=true&lang=js"

import "./Vehicles.vue?vue&type=style&index=0&id=1f1fd856&lang=scss"

const __exports__ = script;

export default __exports__